export const DATETIME_CONSTANTS = {
  MMM_DD_YYY: 'MMM DD, YYYY',
  H_MM: 'H:mm',
  MMM_DD_HH_MM: 'MMM DD, HH:mm',
};
